import React, { ReactElement } from 'react';

import { ReactComponent as CsvIcon } from 'icons/file-types/csv.svg';
import { ReactComponent as DefaultIcon } from 'icons/file-types/default.svg';
import { ReactComponent as DotIcon } from 'icons/file-types/dot.svg';
import { ReactComponent as EmailIcon } from 'icons/file-types/email.svg';
import { ReactComponent as HtmlIcon } from 'icons/file-types/html.svg';
import { ReactComponent as ImageIcon } from 'icons/file-types/image.svg';
import { ReactComponent as OdtIcon } from 'icons/file-types/odt.svg';
import { ReactComponent as PagesIcon } from 'icons/file-types/pages.svg';
import { ReactComponent as PdfIcon } from 'icons/file-types/pdf.svg';
import { ReactComponent as PptIcon } from 'icons/file-types/ppt.svg';
import { ReactComponent as PubIcon } from 'icons/file-types/pub.svg';
import { ReactComponent as RtfIcon } from 'icons/file-types/rtf.svg';
import { ReactComponent as TxtIcon } from 'icons/file-types/txt.svg';
import { ReactComponent as VcfIcon } from 'icons/file-types/vcf.svg';
import { ReactComponent as VideoIcon } from 'icons/file-types/video.svg';
import { ReactComponent as WordIcon } from 'icons/file-types/word.svg';
import { ReactComponent as XlsIcon } from 'icons/file-types/xls.svg';
import { ReactComponent as ZipIcon } from 'icons/file-types/zip.svg';

const SIZE = { width: 48, height: 48 };

const extensions: { [key: string]: ReactElement } = {
  csv: <CsvIcon {...SIZE} />,
  doc: <WordIcon {...SIZE} />,
  docm: <WordIcon {...SIZE} />,
  docx: <WordIcon {...SIZE} />,
  dot: <DotIcon {...SIZE} />,
  eml: <EmailIcon {...SIZE} />,
  gif: <ImageIcon {...SIZE} />,
  heic: <ImageIcon {...SIZE} />,
  htm: <HtmlIcon {...SIZE} />,
  html: <HtmlIcon {...SIZE} />,
  mov: <VideoIcon {...SIZE} />,
  mp4: <VideoIcon {...SIZE} />,
  msg: <EmailIcon {...SIZE} />,
  ods: <XlsIcon {...SIZE} />,
  odt: <OdtIcon {...SIZE} />,
  pages: <PagesIcon {...SIZE} />,
  pdf: <PdfIcon {...SIZE} />,
  ppt: <PptIcon {...SIZE} />,
  pptx: <PptIcon {...SIZE} />,
  pub: <PubIcon {...SIZE} />,
  rtf: <RtfIcon {...SIZE} />,
  tif: <ImageIcon {...SIZE} />,
  tiff: <ImageIcon {...SIZE} />,
  txt: <TxtIcon {...SIZE} />,
  vcf: <VcfIcon {...SIZE} />,
  webm: <VideoIcon {...SIZE} />,
  xls: <XlsIcon {...SIZE} />,
  xlsm: <XlsIcon {...SIZE} />,
  xlsx: <XlsIcon {...SIZE} />,
  zip: <ZipIcon {...SIZE} />,
};

export const DEFAULT_FILE_ICON: ReactElement = <DefaultIcon {...SIZE} />;

export const getFileTypeIcon = (ext?: string): ReactElement =>
  extensions[(ext || '').toLowerCase()] || DEFAULT_FILE_ICON;

export default extensions;
